import { render, staticRenderFns } from "./NewEntryType.vue?vue&type=template&id=97387068&scoped=true"
import script from "./NewEntryType.vue?vue&type=script&lang=js"
export * from "./NewEntryType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97387068",
  null
  
)

export default component.exports